// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"201":"336e4ef5","341":"4d0f92d1","392":"45b62e37","602":"bcb3f46a","717":"13bee2b3","728":"ed1ee571","834":"00631d30"}[chunkId] + ".chunk.css";
};